import CustomHeader from "@src/components/common/appHeader/CustomHeader";
import StepComplete from "@src/components/common/stepComplete/StepComplete";

import "./complete.scss";

export default function FairComplete() {
  const params = new URLSearchParams(window.location.search);
  const isInApp = params.get("isInApp") === "true";

  const goBack = () =>
    isInApp ? (window.location.href = "h2mwbell://webview/close") : window.history.back();

  return (
    <section className="fair-complete-page">
      <CustomHeader
        goBack={goBack}
        close={goBack}
        style={{ maxWidth: "420px", margin: "0 auto" }}
      />
      <StepComplete
        title={`짝짝짝!
      박람회 방문 신청이
      완료되었습니다.`}
        text={`신청해주신 내용은 담당 웨딩플래너가 확인 후
      업무 시간 이내 순차적으로 연락드리겠습니다.
      
      감사합니다.`}
      />
      <button className="btn btn-red500 btn-absolute-circle" onClick={goBack}>
        확인
      </button>
    </section>
  );
}
